export default {
	"schedulecreate": {
		"cancelDispatch": "撤销调度",
		"rePlan": "重新计划",
		"batchDispatch": "批量调度",
		"routeNoStatus": "派车单状态",
		"noDispatched": "未调度",
		"dispatched": "已调度",
		"closed": "已关闭",
		"completed": "已完成",
		"inTransit": "运输中",
		"routeSource": "派车单来源",
		"oppositeAccount": "对方TMS账号",
		"reNotification": "再通知",
		"confirmVehicle": "确认车辆",
		"transportServiceDemand": "运输服务需求",
		"confirmAndDispatch": "确认并调度",
		"acceptJob": "接受任务",
		"dispatchInfo": "调度信息",
		"tickTips": "目前此派车单已选择的服务如下",
		"summaryTips": "这些服务由运单汇总而来",
		"noServicesTips": "没有任何服务...",
		"projectMandatoryTips": "产品/项目必选服务",
		"clickServiceSelectTips": "点击下面运单数据可选择对应的服务",
		"pleaseTips": "请为",
		"selectServiceTips": "单据选择需要的服务项",
		"pleaseSelectWaybillTips": "请在上面的运单列表中点选一条运单数据",
		"pleaseSelectRouteNo": "请选择派车单",
		"pleaseSelectNoDispatchedRouteNo": "只能选择未调度的派车单",
		"pleaseSelectCarrier": "请选择承运商",
		"pleaseSelectConsignedProduct": "请选择托运产品",
		"batchDispatchTips": "批量调度提示",
		"batchDispatchSuccess": "批量调度成功",
		"pleaseSpecifyVehicleInfo": "请指定车辆信息",
		"dispatchLetter": "调度函",
		"documentStatusIs": "单据状态为",
		"unableToShow": "无法展示",
		"continueRePlan": "是否继续重新计划?",
		"rePlanSuccess": "重新计划成功",
		"pleaseSelectOnlyOne": "请选择派车单（只允许选择一个派车单）",
		"cancelDispatchTips": "是否继续撤销调度?",
		"cancelDispatchLetter": "撤销调度函",
		"cancelSuccess": "撤销成功",
		"pleaseInputcorrectNo": "请输入正确司机电话！",
		"licenseHasExpired": "此司机驾照已过期，是否使用此司机",
		"fleetDisabled": "此车队已被禁用，是否使用此司机",
		"fleetDisabledTips": "此车队已被禁用，是否使用此车辆",
		"vehicleNotAnnualReview": "此车辆未按时年审，是否使用此车辆",
		"vehicleInsuranceExpires": "此车辆保险已过期，是否使用此车辆",
		"cannotSelect1": "此司机已被禁用，不能选择",
		"cannotSelect2": "此司机已无分数，不能选择",
		"cannotSelect3": "此车辆已被禁用，不能选择",
		"ownCar": "自有车",
		"individualDriver": "个体司机",
		"carrierSelectTips": "承运商选择个体司机或自有司机时，必须要有车辆信息",
		"driverNotNull": "车辆信息列表中，司机不能为空",
		"driverPhoneNoNotNull": "车辆信息列表中，司机手机号不能为空",
		"vehicleTypeNotNull": "车辆信息列表中，车型不能为空",
		"plateNoNotNull": "车辆信息列表中，车牌不能为空",
		"dispatchSuccess": "调度成功",
		"noVehicleInfoTips": "没有车辆信息！，是否确认不需要车辆信息？",
		"vehicle": "车辆",
		"paperStyle": "纸质单样式",
		"minSizeGtMsg": "多个运单拼车运输，不能多辆车运输！",
		"planInfo": "计划信息",
		"pleaseSelectOnlyOne2": "多单路单调度时只可选择一种车型",
		"addVehicle": "添加车辆",
		"vehicleInfoTips": "搜索车辆信息",
		"searchTrackerTips": "搜索跟踪器信息",
		"newCapacityDriver": "新运力司机",
		"newCapacityMobile": "新运力手机",
		"newCapacityVehicleType": "新运力车型",
		"newCapacityPlateNo": "新运力车牌",
		"newCapacityCertificateNo": "新运力证件号",
		"live": "实况",
		"noTemperature": "无温度",
		"numberData": "条数据！",
		"atLeastKeep": "至少保留",
		"senderCity": "发货市/区",
		"receiverCity": "收货市/区",
		"cancelWaybillTips": "确定取消运单吗?",
		"downloadRouteNo": "下载派车单",
		"mustPickingUpGoods": "提货时必须要提货单",
		"downloadDeliverygoods": "下载提货单",
		"otherDocument": "其他文件",
		"clickDownloadTips": "如果作业时还需要以下单据请点击下载",
		"downloadAll": "全部打包下载",
		"bill": "单据",
		"billNo": "单号",
		"download": "下载",
		"invalidFileObject": "无效的文件对象",
		"handoverSheet": "交接单",
		"noSend": "不发送",
		"send": "发送",
		"emailSubject": "邮件主题",
		"inputEmailSubject": "请输入邮件主题",
		"shortMessageInfo": "短信内容",
		"truck": "Truck",
		"addTruck": "add a truck",
		"trailer": "Trailer",
		"addTrailer": "add a trailer",
		"subcontractorTruck": "Subcontractor Truck",
		"subcontractorTrailer": "Subcontractor Trailer",
		"selectTrailerType": "Select Trailer Type",
		"trailerTypeRequired": "Trailer Type is required",
		"plateNumberRequired": "Plate Number is required",
		"trailerProvincialSignRequired": "Trailer Provincial Sign is required",
		"driverRequired": "Driver is required",
		"contactNumberRequired": "Contact Number is required",
		"actualVehicleTypeRequired": "Actual Vehicle Type is required",
		"licencseNumberRequired": "License Number is required",
		"truckProvincialSignRequired": "Provincial Sign is required",
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/schedule/schedule.js